import { Asset } from './asset.model';

export abstract class AssetList {
  items: Asset[];
  total: number;
}
